var map = {
	"./about.png": 4722,
	"./about1.jpg": 4876,
	"./about2.jpg": 9151,
	"./about3.jpg": 5023,
	"./appointment.png": 4605,
	"./cardiogram.png": 669,
	"./clock.png": 2211,
	"./contacts.png": 4823,
	"./dining-table.png": 1882,
	"./doctor.jpg": 4748,
	"./doctor.png": 140,
	"./edit.png": 8975,
	"./first-aid-kit.png": 9899,
	"./gmail.png": 7560,
	"./home.png": 6553,
	"./homePage.png": 6013,
	"./login_bg.jpg": 5217,
	"./magnifier.png": 3986,
	"./messages.png": 8115,
	"./phone-call.png": 7767,
	"./placeholder.png": 3711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;